import { Copy, Edit2, Eye, EyeOff, Trash2 } from 'lucide-react';
import { SpaceListItem } from '../../hooks/useAdminSpaces';
import { IconButton } from './IconButton';

interface CardActionsProps {
  space: SpaceListItem;
  onEdit: (id: string) => void;
  onToggle: (id: string, field: string) => void;
  onDuplicate: (id: string) => void;
  onDelete: (id: string, name: string) => void;
  actionInProgress: boolean;
}

export function CardActions({
  space,
  onEdit,
  onToggle,
  onDuplicate,
  onDelete,
  actionInProgress,
}: CardActionsProps) {
  return (
    <div
      style={{
        marginTop: 'auto',
        display: 'flex',
        gap: '0.5rem',
        paddingTop: '1.25rem',
        borderTop: '1px solid #f0f0f0',
      }}
    >
      <button
        onClick={() => onEdit(space.id)}
        disabled={actionInProgress}
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '0.5rem',
          padding: '0.75rem',
          background: 'linear-gradient(135deg, #00758d 0%, #00303c 100%)',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          fontSize: '0.9rem',
          fontWeight: 600,
          cursor: actionInProgress ? 'not-allowed' : 'pointer',
          transition: 'all 0.2s ease',
        }}
      >
        <Edit2 size={16} />
        Éditer
      </button>

      <div style={{ display: 'flex', border: '2px solid #e5e7eb', borderRadius: '8px', overflow: 'hidden' }}>
        <button
          onClick={() => onToggle(space.id, 'isActive')}
          disabled={actionInProgress}
          style={{
            padding: '0.75rem',
            background: space.isActive ? 'rgba(0,117,141,0.1)' : 'transparent',
            color: space.isActive ? '#00758d' : '#666',
            border: 'none',
            borderRight: '1px solid #e5e7eb',
            cursor: actionInProgress ? 'not-allowed' : 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          title={space.isActive ? 'Désactiver' : 'Activer'}
        >
          {space.isActive ? 'Opérationnel' : "À l'arrêt"}
        </button>
        <button
          onClick={() => onToggle(space.id, 'isPublic')}
          disabled={actionInProgress}
          style={{
            padding: '0.75rem',
            background: space.isPublic ? 'rgba(0,117,141,0.1)' : 'transparent',
            color: space.isPublic ? '#00758d' : '#666',
            border: 'none',
            cursor: actionInProgress ? 'not-allowed' : 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          title={space.isPublic ? 'Rendre privé' : 'Publier'}
        >
          {space.isPublic ? <Eye size={16} /> : <EyeOff size={16} />}
        </button>
      </div>

      <IconButton icon={<Copy size={16} />} onClick={() => onDuplicate(space.id)} disabled={actionInProgress} title="Dupliquer" />
      <IconButton icon={<Trash2 size={16} />} onClick={() => onDelete(space.id, space.name)} disabled={actionInProgress} title="Supprimer" danger />
    </div>
  );
}
